import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Header, Segment, Grid, Image, Divider } from "semantic-ui-react";
import { useClient } from "../../hooks/use-client";

interface PublicAuthFormWrapperProps {
  children: React.ReactNode;
  title: string;
  documentTitle?: string;
}

export const PublicAuthFormWrapper = ({ children, title, documentTitle }: PublicAuthFormWrapperProps) => {
  const { site } = useParams<{ site: string }>();
  const client = useClient(site);
  const cityName = useMemo(() => client.query.data?.payload?.data?.attributes?.name, [client.query.data]);
  const citySeal = useMemo(() => client.query.data?.payload?.data?.attributes?.seal, [client.query.data]);

  if (documentTitle) document.title = documentTitle;

  return (
    <Grid
      verticalAlign='middle'
      textAlign='center'
      className='tw-m-0 tw-mb-0 tw-h-full tw-w-full tw-bg-white sm:tw-bg-transparent'
    >
      <Grid.Column className='tw-w-full tw-min-w-[16rem] tw-max-w-[36rem] tw-bg-white tw-pb-12 tw-pt-12 tw-text-left sm:tw-bg-transparent sm:tw-pt-24'>
        <Grid.Row className='tw-flex tw-justify-center'>
          <Segment className='tw-m-0 tw-w-full tw-border-none tw-p-0 tw-shadow-none sm:tw-border-solid sm:tw-border-[#22242626] sm:tw-shadow-sm'>
            <div className='tw-relative'>
              <Image
                src={citySeal}
                className='tw-absolute tw-left-1/2 tw-z-10 tw-w-[80px] tw-translate-x-[-50%] tw-translate-y-[-30%] tw-transform sm:tw-w-[100px] sm:tw-translate-y-[-50%]'
                alt=''
              />
            </div>
            <div className='tw-p-7'>
              <Header textAlign='center' className='tw-mb-6 tw-mt-10 tw-text-[24px] tw-font-semibold'>
                {cityName}
              </Header>
              <Divider className='-tw-mx-7' />
              <Header as='h1' textAlign='center' className='tw-my-6 tw-text-[18px] tw-font-semibold'>
                {title}
              </Header>
              {children}
            </div>
          </Segment>
        </Grid.Row>
        <Grid.Row className='tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-6 xxs:tw-flex-nowrap xxs:tw-justify-between'>
          <div>
            <Image src='/assets/powered-by-gogov.png' className='tw-w-32' alt='Powered by GoGov' />
          </div>
          <div className='-tw-mt-4 tw-text-sm tw-text-grey'>Copyright &copy; {new Date().getFullYear()} GOGov</div>
        </Grid.Row>
      </Grid.Column>
    </Grid>
  );
};

export default PublicAuthFormWrapper;
